// extracted by mini-css-extract-plugin
export default {"main":"CaseStudies_main__wCwTC","head":"CaseStudies_head__2cLrU","box":"CaseStudies_box__agVcR","bottomRow":"CaseStudies_bottomRow__4y7st","readMore":"CaseStudies_readMore__awUY1"};